import React from 'react'
import { PropTypes } from 'prop-types'
import { graphql } from '@apollo/client/react/hoc'
import { flowRight } from 'lodash'

import ActionLogic from './Util/ActionLogic'

import writeVehicleValueMutation from 'graphql/keyvalues/writeVehicleValue.gql'
import writeUserValueMutation from 'graphql/keyvalues/writeUserValue.gql'

export const AppKeyValuesLogicContext = React.createContext()

class AppKeyValuesLogic extends React.Component {
    writeVehicleKeyValue = (actionLogic, entityId, key, value) => {
        return actionLogic.callMutation(this.props.writeVehicleValue, {
            variables: {
                input: {
                    entityId: parseInt(entityId),
                    key: key,
                    value: value,
                },
            },
        })
    }

    writeUserKeyValue = (actionLogic, key, value) => {
        return actionLogic.callMutation(this.props.writeUserValue, {
            variables: {
                input: {
                    key: key,
                    value: value,
                },
            },
        })
    }

    render () {
        return (
            <ActionLogic>
                {(actionLogic) => {
                    const props = {
                        ...actionLogic,
                        writeVehicleKeyValue: (...args) => this.writeVehicleKeyValue(actionLogic, ...args),
                        writeUserKeyValue: (...args) => this.writeUserKeyValue(actionLogic, ...args),
                    }
                    return (
                        <AppKeyValuesLogicContext.Provider value={props}>
                            {this.props.children}
                        </AppKeyValuesLogicContext.Provider>
                    )
                }}
            </ActionLogic>
        )
    }
}

AppKeyValuesLogic.propTypes = {
    children: PropTypes.node.isRequired,
}

export default flowRight(
    graphql(writeVehicleValueMutation, { name: 'writeVehicleValue' }),
    graphql(writeUserValueMutation, { name: 'writeUserValue' }),
)(AppKeyValuesLogic)
